window.$ = window.jQuery = require('jquery');
require('overlayscrollbars');
require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte.min.js');
require('./bootstrap');
require('bootstrap');
require('fomantic-ui');
require('./php');
import Cookies from 'js-cookie'
import { defaultsDeep } from 'lodash';

window.Cookies = Cookies;
window.App = {
	csrfToken: ''
};

//----- ヘルパー：クッキー -----
window.cookie_get = function(name, key) {
	var data = Cookies.get(name);
	data = $.parseJSON(data || null);
	if(php.empty(data)) data = {};

	if(key !== void 0) {
		return data[key];
	}
	
	return data;
};
window.cookie_set = function(name, key, value) {
	var data = cookie_get(name);
	data[key] = value;
	Cookies.set(name, data);
};
window.cms_cookie_get = function(key) {
	return cookie_get('cms', key);
};
window.cms_cookie_set = function(key, value) {
	cookie_set('cms', key, value);
};
window.adminlte_cookie_get = function(key) {
	return cookie_get('adminlte', key);
};
window.adminlte_cookie_set = function(key, value) {
	cookie_set('adminlte', key, value);
};
//-----

$(function()
{
	if(!window.App.csrfToken) {
		window.App.csrfToken = $('meta[name=csrf-token]').prop('content');
	}

	//----- 各フォームのヘルプ
	$('body form .help-tooltip').popup({
		inline: true,
	});
	//-----

	//----- 検索フォームの開閉記憶 -----
	var $collapse_search = $('#collapse_search');
	if($collapse_search.length)
	{
		var set_collapse = function(value) {
			adminlte_cookie_set('collapse-toggle-' +  location.pathname, value);
		};
		
		$collapse_search.on('show.bs.collapse', function (e) {
			set_collapse('1');
			$('.ui.button.btnCollapseSearch').addClass('green');
			$('.search_quick_keyword').fadeOut();
		});
		$collapse_search.on('hide.bs.collapse', function (e) {
			set_collapse('0');
			$('.ui.button.btnCollapseSearch').removeClass('green');
			//ui action input
			$('.search_quick_keyword').fadeIn();
		});
	}
	//-----

	//----- 検索フォームのクイック検索の入力内容を同期 -----
	var $searchBoxKeyword = $('.searchBox .searchBoxKeyword');
	var $form = $searchBoxKeyword.closest('form');
	var $input = $form.find('input[name=' + $searchBoxKeyword.prop('name') + ']:last');
	$searchBoxKeyword.on('input', function(e)
	{
		$input.val($(this).val());
	});
	$input.on('input', function()
	{
		$searchBoxKeyword.val($(this).val());
	});
	$form.on('keydown', function(e)
	{
		if (e.keyCode == 13)
		{
			$(e.target).closest('.input').addClass('loading');
			$form.find('.btnNext').trigger('click');
			return false;
		}
	});
	//-----

	//----- フォーム送信処理制御 -----
	$(".btnPre, .btnSubmit, .btnBack, .btnNext").click(function ()
	{
		var $btnSubmit = $(this);
		
		if(!$btnSubmit.hasClass('disabled') && !$btnSubmit.hasClass('loading'))
		{
			$btnSubmit.addClass('disabled loading');
			
			if($btnSubmit.data('loading-time'))
			{
				setTimeout(function () {
					$btnSubmit.removeClass('disabled loading');
				}, $btnSubmit.data('loading-time'));
			}
		}

		if($btnSubmit.hasClass('btnPre'))
		{
			$($btnSubmit.data('target')).click();
			// $($btnSubmit.data('target')).trigger('click');
			return false;
		}

		
		var $form = $btnSubmit.closest('form');
		var name = $btnSubmit.data('name');
		var value = $btnSubmit.data('value');
		
		if(!name)
		{
			if($btnSubmit.hasClass('btnBack'))
			{
				name = '_back';
				value = '1';
			}
			else if($btnSubmit.hasClass('btnNext'))
			{
				name = '_next';
				value = '1';
			}
		}
		
		$form.append('<input type="hidden" name="' + name + '" value="' + value + '" />');

		var action = $btnSubmit.data('action');

		if (action)
		{
			$form.attr('action', php.rtrim(action, '/'));
		}
		
		$form.submit();
		return false;
	});
	//-----
	
	//----- select系のreadonlyの制御 -----
	$('select[readonly="readonly"]').on('focus', function()
	{
		var $self = $(this);
		$self.data('default', $self.val());
	}).on('change', function(e)
	{
		var $self = $(this);
		$self.val($self.data('default'));
	});
	//-----
	
	//----- table > tbody > trクリックによる移動制御 -----
	$('.trJump, .liJump').on('click', function(e)
	{
		var $self = $(this);
		var target_tag = $self.hasClass('trJump') ? 'td' : 'li';
		var $target = $(e.target);
		var tag = $target[0].nodeName.toLowerCase();
		var $td = tag === target_tag ? $target : $target.closest(target_tag);
		var exists_not_jump = false;

		if($td.hasClass('notJump')) {
			exists_not_jump = true;
		} else if(tag !== target_tag) {
			if($target.closest('.notJump').length > 0) {
				exists_not_jump = true;
			}
		}

		if($self.data('href') && !exists_not_jump)
		{
			if($self.data('target'))
			{
				window.open($self.data('href'), $self.data('target'));
			}
			else
			{
				window.location.href = $self.data('href');
			}
		}

		// e.stopPropagation();
	});
	//-----
	
	$.fn.dropdown.settings.message = {
		addResult     : '<b>{term}</b>を追加',
		count         : '{count}件選択済み',
		maxSelections : '{maxCount}件まで選択可能',
		noResults     : 'データが見つかりません'
	};

	//----- hover時にメニュー表示(ログ、テーブルのメニュー) -----
	$('.ui.inline.logs.dropdown, .menu > .menu > .ui.dropdown').dropdown({
		on: 'hover',
	});
	//-----

	$('.ui.dropdown:not(.upward,.manual)').dropdown({clearable: true, fullTextSearch:true});
	$('.ui.dropdown.upward:not(.manual)').dropdown({clearable: true, direction: 'upward', fullTextSearch:true});
	$('.ui.dropdown').on('focus', '.search', function()
	{
		var $self = $(this);
		$self.prop('autocomplete', 'nope');
	});
	$('.ui.calendar input').on('focus', function()
	{
		var $self = $(this);
		$self.prop('autocomplete', 'nope');
	});






	
	$.fn.calendar.settings.text = {
		days: ['日', '月', '火', '水', '木', '金', '土'],
		months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		today: '今日',
		now: '今日',
		am: 'AM',
		pm: 'PM',
		weekNo: '週'
	};
	$.fn.calendar.settings.ampm = false;
	$.fn.calendar.settings.today = true;
	$.fn.calendar.settings.formatter.yearHeader = function (date, settings) {
		var decadeYear = Math.ceil(date.getFullYear() / 10) * 10;
		return (decadeYear - 9) + ' ～ ' + (decadeYear + 2) + '年';
    };
	$.fn.calendar.settings.formatter.monthHeader = function (date, settings) {
		return date.getFullYear();
	};
	$.fn.calendar.settings.formatter.dayHeader = function (date, settings) {
		var month = settings.text.months[date.getMonth()];
		var year = date.getFullYear();
		return year + '年' + month;
	};
	$.fn.calendar.settings.formatter.date = function (date, settings) {
		if (!date) {
			return '';
		}
		var day = date.getDate();
		var month = date.getMonth() + 1;
		var year = date.getFullYear();
		return settings.type === 'year' ? year :
			settings.type === 'month' ? year + '年' + php.sprintf('%02s', month) + '月' :
			php.sprintf('%04s/%02s/%02s', year, month, day);
	};
	$.fn.calendar.settings.formatter.time = function (date, settings, forCalendar) {
		if (!date) {
			return '';
		}
		var hour = date.getHours();
		var minute = date.getMinutes();
		var ampm = '';
		if (settings.ampm) {
			ampm = (hour < 12 ? settings.text.am : settings.text.pm) + ' ';
			hour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
		}
		return ampm + php.sprintf('%02s:%02s', hour, minute);
	};
});

